module.exports = __webpack_public_path__ + "static/media/img0011.2732d5a7.jpg";